module.exports = __webpack_public_path__ + "static/media/Divya Pal.523858e5.png";